import { useTranslation } from 'react-i18next';
import { ProColumns } from '@ant-design/pro-components';
import { useState } from 'react';
import CustomProTable, { tablePagination } from 'base/ui/components/CustomTable';
import { SearchModel } from 'pages/model';
import { PAGE_SIZE_DEFAULT } from 'utils/constants';
import { contactSegmentPresenter, contactSegmentStore } from 'stores/root_store';
import { observer } from 'mobx-react';
import { ActivitiesOfContactSegment } from 'services/Main/contactSegment_services';

type ActivitiesTabProps = {
  contactSegmentationId: string;
};

function ActivitiesTab(props: ActivitiesTabProps) {
  const { contactSegmentationId } = props;
  const { t } = useTranslation();

  const [columns, setColumns] = useState<ProColumns<ActivitiesOfContactSegment>[]>([
    {
      title: t('zalo-notification.stt'),
      dataIndex: 'stt',
      key: 'stt',
      fixed: 'left',
      width: 50,
      align: 'center',
    },
    // Mã CRM (ID hoạt động)
    {
      // title: t('segment.ma-crm'),
      title: 'ID hoạt động',
      dataIndex: 'crmCode',
      key: 'crmCode',
      fixed: 'left',
      width: 100,
    },
    // Tiêu đề
    {
      title: t('segment.tieu-de'),
      dataIndex: 'title',
      key: 'title',
      fixed: 'left',
      width: 200,
    },
    // Hoạt động (anh phúc bảo ẩn ngày 23/04/24)
    // {
    //   title: t('segment.hoat-dong'),
    //   dataIndex: 'type',
    //   key: 'type',
    //   width: 150,
    // },
    // Loại
    {
      title: t('segment.loai'),
      dataIndex: 'type',
      key: 'type',
      width: 150,
    },
    // Trạng thái
    {
      title: t('segment.trang-thai'),
      dataIndex: 'status',
      key: 'status',
      width: 150,
    },
    //   Người tạo
    // {
    //   title: t('Người tạo'),
    //   dataIndex: 'diaChi',
    //   key: 'diaChi',
    //   width: 100,
    // },
    //   Ngày tạo
    {
      title: t('segment.ngay-tao'),
      dataIndex: 'createTime',
      key: 'createTime',
      width: 150,
      valueType: 'dateTime',
      fieldProps: {
        format: 'DD/MM/YYYY HH:mm:ss',
      },
      onCell: (_, index) => ({
        className: 'text-center',
      }),
    },
    // Mã liên hệ - Mã KH
    {
      title: 'Mã liên hệ',
      dataIndex: 'customerCode',
      key: 'customerCode',
      width: 150,
    },
    // Tên liên hệ - Tên KH
    {
      title: 'Tên liên hệ',
      dataIndex: 'customerName',
      key: 'customerName',
      width: 200,
    },
    //  Email
    {
      title: t('segment.email'),
      dataIndex: 'email',
      key: 'email',
      width: 150,
    },
    //  Contact - SĐT liên hệ
    {
      title: 'SĐT liên hệ',
      dataIndex: 'contact',
      key: 'contact',
      width: 150,
    },
  ]);

  // --------- NHIỆM VỤ ------------------------------------------------------------
  const [dataMission, setDataMission] = useState<ActivitiesOfContactSegment[]>([]);
  const [dataPagingMission, setDataPagingMission] = useState<SearchModel>({
    type: 'ACTIVITIES',
    contactSegmentationId: contactSegmentationId,
    paging: {
      pageSize: PAGE_SIZE_DEFAULT,
      pageIndex: 1,
      orderBy: undefined,
      orderByDesc: undefined,
    },
  });
  // số record nhiệm vụ
  const [totalCountMission, setTotalCountMission] = useState(0);

  // --------- THĂM HỎI KHÁCH HÀNG ------------------------------------------------------------
  const [dataTHKH, setDataTHKH] = useState<ActivitiesOfContactSegment[]>([]);
  const [dataPagingTHKH, setDataPagingTHKH] = useState<SearchModel>({
    type: 'THKH',
    contactSegmentationId: contactSegmentationId,
    paging: {
      pageSize: PAGE_SIZE_DEFAULT,
      pageIndex: 1,
      orderBy: undefined,
      orderByDesc: undefined,
    },
  });
  // số record nhiệm vụ
  const [totalCountTHKH, setTotalCountTHKH] = useState(0);

  // --------- KHÁCH GHÉ THĂM ------------------------------------------------------------
  const [dataKGT, setDataKGT] = useState<ActivitiesOfContactSegment[]>([]);
  const [dataPagingKGT, setDataPagingKGT] = useState<SearchModel>({
    type: 'GT',
    contactSegmentationId: contactSegmentationId,
    paging: {
      pageSize: PAGE_SIZE_DEFAULT,
      pageIndex: 1,
      orderBy: undefined,
      orderByDesc: undefined,
    },
  });
  // số record nhiệm vụ
  const [totalCountKGT, setTotalCountKGT] = useState(0);

  // --------- BẢO HÀNH/XLKN ------------------------------------------------------------
  const [dataBHXLKN, setDataBHXLKN] = useState<ActivitiesOfContactSegment[]>([]);
  const [dataPagingBHXLKN, setDataPagingBHXLKN] = useState<SearchModel>({
    type: 'TICKET,TIKECT_MLC',
    contactSegmentationId: contactSegmentationId,
    paging: {
      pageSize: PAGE_SIZE_DEFAULT,
      pageIndex: 1,
      orderBy: undefined,
      orderByDesc: undefined,
    },
  });
  // số record nhiệm vụ
  const [totalCountBHXLKN, setTotalCountBHXLKN] = useState(0);

  // ======= LẤY DATA ===================================================================================================

  // lấy data nhiệm vụ
  const getDataTableMission = async (dataSearch: SearchModel) => {
    await contactSegmentPresenter.getActivitiesOfContactSegment(contactSegmentStore, dataSearch);
    if (contactSegmentStore.activitiesOfContactSegment.isSuccess) {
      setDataMission(contactSegmentStore.activitiesOfContactSegment.data);
      setTotalCountMission(contactSegmentStore.activitiesOfContactSegment.paging?.totalCount || 0);
      return contactSegmentStore.activitiesOfContactSegment.data;
    }
    return [];
  };

  // lấy data thăm hỏi khách hàng
  const getDataTableTHKH = async (dataSearch: SearchModel) => {
    await contactSegmentPresenter.getActivitiesOfContactSegment(contactSegmentStore, dataSearch);
    if (contactSegmentStore.activitiesOfContactSegment.isSuccess) {
      setDataTHKH(contactSegmentStore.activitiesOfContactSegment.data);
      setTotalCountTHKH(contactSegmentStore.activitiesOfContactSegment.paging?.totalCount || 0);
      return contactSegmentStore.activitiesOfContactSegment.data;
    }
    return [];
  };

  // lấy data khách ghé thăm
  const getDataTableKGT = async (dataSearch: SearchModel) => {
    await contactSegmentPresenter.getActivitiesOfContactSegment(contactSegmentStore, dataSearch);
    if (contactSegmentStore.activitiesOfContactSegment.isSuccess) {
      setDataKGT(contactSegmentStore.activitiesOfContactSegment.data);
      setTotalCountKGT(contactSegmentStore.activitiesOfContactSegment.paging?.totalCount || 0);
      return contactSegmentStore.activitiesOfContactSegment.data;
    }
    return [];
  };

  // lấy data Bảo hành/XLKN
  const getDataTableBHXLKN = async (dataSearch: SearchModel) => {
    await contactSegmentPresenter.getActivitiesOfContactSegment(contactSegmentStore, dataSearch);
    if (contactSegmentStore.activitiesOfContactSegment.isSuccess) {
      setDataBHXLKN(contactSegmentStore.activitiesOfContactSegment.data);
      setTotalCountBHXLKN(contactSegmentStore.activitiesOfContactSegment.paging?.totalCount || 0);
      return contactSegmentStore.activitiesOfContactSegment.data;
    }
    return [];
  };


  return (
    <div className="w-full mt-3 flex flex-col gap-default">
      {/* --------- NHIỆM VỤ ------------------------------------------------------------ */}
      <div className="w-full p-2 rounded-sm shadow-box border-2 border-transparent border-t-primary">
        <CustomProTable<ActivitiesOfContactSegment>
          bordered
          headerTitle={<h2 className="text-sm font-bold uppercase">{t('segment.nhiem-vu')}</h2>}
          columns={columns}
          dataSource={dataMission}
          handleResize={() => { }}
          rowKey="stt"
          request={async (params = {}, sort, filter) => {
            const data = await getDataTableMission({
              ...dataPagingMission,
              paging: {
                ...dataPagingMission.paging,
                orderBy: Object.values(sort)[0] === 'ascend' ? `${Object.keys(sort)[0].split(',').pop()}` : undefined,
                orderByDesc:
                  Object.values(sort)[0] === 'descend' ? `${Object.keys(sort)[0].split(',').pop()}` : undefined,
              },
            });

            if (Object.values(sort).length) {
              setDataPagingMission({
                ...dataPagingMission,
                paging: {
                  ...dataPagingMission.paging,
                  orderBy: Object.values(sort)[0] === 'ascend' ? `${Object.keys(sort)[0].split(',').pop()}` : undefined,
                  orderByDesc:
                    Object.values(sort)[0] === 'descend' ? `${Object.keys(sort)[0].split(',').pop()}` : undefined,
                },
              });
            }
            return {
              data: data,
              success: contactSegmentStore.activitiesOfContactSegment.isSuccess,
            };
          }}
          pagination={{
            ...tablePagination(dataPagingMission, setDataPagingMission),
            total: totalCountMission,
          }}
          options={{
            setting: false,
            density: false,
            fullScreen: false,
            reload: false,
          }}
        />
      </div>

      {/*  --------- THĂM HỎI KHÁCH HÀNG ------------------------------------------------------------ */}
      <div className="w-full p-2 rounded-sm shadow-box border-2 border-transparent border-t-primary">
        <CustomProTable<ActivitiesOfContactSegment>
          bordered
          className="w-full"
          headerTitle={<h2 className="text-sm font-bold uppercase">{t('segment.th-kh')}</h2>}
          columns={columns}
          dataSource={dataTHKH}
          handleResize={() => { }}
          rowKey="stt"
          request={async (params = {}, sort, filter) => {
            const data = await getDataTableTHKH({
              ...dataPagingTHKH,
              paging: {
                ...dataPagingTHKH.paging,
                orderBy: Object.values(sort)[0] === 'ascend' ? `${Object.keys(sort)[0].split(',').pop()}` : undefined,
                orderByDesc:
                  Object.values(sort)[0] === 'descend' ? `${Object.keys(sort)[0].split(',').pop()}` : undefined,
              },
            });

            if (Object.values(sort).length) {
              setDataPagingTHKH({
                ...dataPagingTHKH,
                paging: {
                  ...dataPagingTHKH.paging,
                  orderBy: Object.values(sort)[0] === 'ascend' ? `${Object.keys(sort)[0].split(',').pop()}` : undefined,
                  orderByDesc:
                    Object.values(sort)[0] === 'descend' ? `${Object.keys(sort)[0].split(',').pop()}` : undefined,
                },
              });
            }
            return {
              data: data,
              success: contactSegmentStore.activitiesOfContactSegment.isSuccess,
            };
          }}
          pagination={{
            ...tablePagination(dataPagingTHKH, setDataPagingTHKH),
            total: totalCountTHKH,
          }}
          options={{
            setting: false,
            density: false,
            fullScreen: false,
            reload: false,
          }}
        />
      </div>

      {/*  --------- KHÁCH GHÉ THĂM ------------------------------------------------------------ */}
      <div className="w-full p-2 rounded-sm shadow-box border-2 border-transparent border-t-primary">
        <CustomProTable<ActivitiesOfContactSegment>
          bordered
          className="w-full"
          headerTitle={<h2 className="text-sm font-bold uppercase">{t('segment.visit-customer')}</h2>}
          columns={columns}
          dataSource={dataKGT}
          rowKey="stt"
          request={async (params = {}, sort, filter) => {
            const data = await getDataTableKGT({
              ...dataPagingKGT,
              paging: {
                ...dataPagingKGT.paging,
                orderBy: Object.values(sort)[0] === 'ascend' ? `${Object.keys(sort)[0].split(',').pop()}` : undefined,
                orderByDesc:
                  Object.values(sort)[0] === 'descend' ? `${Object.keys(sort)[0].split(',').pop()}` : undefined,
              },
            });

            if (Object.values(sort).length) {
              setDataPagingKGT({
                ...dataPagingKGT,
                paging: {
                  ...dataPagingKGT.paging,
                  orderBy: Object.values(sort)[0] === 'ascend' ? `${Object.keys(sort)[0].split(',').pop()}` : undefined,
                  orderByDesc:
                    Object.values(sort)[0] === 'descend' ? `${Object.keys(sort)[0].split(',').pop()}` : undefined,
                },
              });
            }
            return {
              data: data,
              success: contactSegmentStore.activitiesOfContactSegment.isSuccess,
            };
          }}
          pagination={{
            ...tablePagination(dataPagingKGT, setDataPagingKGT),
            total: totalCountKGT,
          }}
          options={{
            setting: false,
            density: false,
            fullScreen: true,
            reload: true,
          }}
        />
      </div>

      {/*  --------- BẢO HÀNH/XLKN ------------------------------------------------------------ */}
      <div className="w-full p-2 rounded-sm shadow-box border-2 border-transparent border-t-primary">
        <CustomProTable<ActivitiesOfContactSegment>
          bordered
          className="w-full"
          headerTitle={<h2 className="text-sm font-bold uppercase">{t('segment.ticket')}</h2>}
          columns={columns}
          dataSource={dataBHXLKN}
          rowKey="stt"
          request={async (params = {}, sort, filter) => {
            const data = await getDataTableBHXLKN({
              ...dataPagingBHXLKN,
              paging: {
                ...dataPagingBHXLKN.paging,
                orderBy: Object.values(sort)[0] === 'ascend' ? `${Object.keys(sort)[0].split(',').pop()}` : undefined,
                orderByDesc:
                  Object.values(sort)[0] === 'descend' ? `${Object.keys(sort)[0].split(',').pop()}` : undefined,
              },
            });

            if (Object.values(sort).length) {
              setDataPagingBHXLKN({
                ...dataPagingBHXLKN,
                paging: {
                  ...dataPagingBHXLKN.paging,
                  orderBy: Object.values(sort)[0] === 'ascend' ? `${Object.keys(sort)[0].split(',').pop()}` : undefined,
                  orderByDesc:
                    Object.values(sort)[0] === 'descend' ? `${Object.keys(sort)[0].split(',').pop()}` : undefined,
                },
              });
            }
            return {
              data: data,
              success: contactSegmentStore.activitiesOfContactSegment.isSuccess,
            };
          }}

          pagination={{
            ...tablePagination(dataPagingBHXLKN, setDataPagingBHXLKN),
            total: totalCountBHXLKN,
          }}
          options={{
            setting: false,
            density: false,
            fullScreen: true,
            reload: true,
          }}
        />
      </div>
    </div>
  );
}

export default observer(ActivitiesTab);
